news11.vue<template>
<div>
		<sub-header bizCd="10"/>
	 	<div class="sub_visual sub10">
            <div class="container">
                <div class="sub_txt">
                    <div class="tit">보도자료</div>
                    <div class="comment">언론에 소개된 에듀윌의 다양한 소식을 만나보세요.</div>
                </div>
            </div>
        </div>
        <div class="contents aos-all">
            <div class="container">
                <div class="sec">
                    <h3>보도자료</h3>
                    <div class="board">
                        <div class="board_header">
                            <h4>에듀윌, EBS미디어, 메이트아이, 액티부키, 동남아시아 시장 진출 위한 공동 MOU 체결</h4>
                            <div class="board_meta">
<!--                                <ul>-->
<!--                                    <li>등록일 : 22.05.24</li>-->
<!--                                    <li>조회수 : 142</li>-->
<!--                                </ul>-->
                            </div>
                        </div>
                      <div class="board_body">
                            <div class="board_content">
                              <h2>에듀윌, EBS미디어, 메이트아이, 액티부키, 동남아시아 시장 진출 위한 공동 MOU 체결</h2>
                              <p>&nbsp;</p>
                              <p>- 교육과 관광, IP 콘텐츠의 융합을 통한 혁신적인 서비스 제공<br>- 연내 라오스 정부 부처와 구체적인 사업 논의 시작<br>- 협의체 및 파일럿
                                프로그램 운영…현지에서의 영향력 확대해 나갈 예정</p>
                              <p><br>

                                <figure class="image"><img src="//company.eduwill.net/contents/img/20250131172111.jpg"></figure>

                                <br>▲사진 설명: 지난 25일, 에듀윌 본사에서 이정협 라오스
                                산업통상부 경제자문관, 김민수 메이트아이 대표, 양형남 에듀윌 대표, 박성호 EBS미디어 대표, 이동원 액티부키 대표(왼쪽부터)가 MOU를 체결하고 기념촬영을
                                하고 있다.</p>
                              <p>&nbsp;</p>
                              <p><br>(2024-09-26) 종합교육기업 에듀윌(대표 양형남)이 국내 교육 및 콘텐츠 산업을 선도하는 EBS미디어, 메이트아이(호텔엔조이), 액티부키와
                                지난 25일, 서울 구로구에 위치한 에듀윌 본사에서 라오스를 비롯한 동남아시아 시장 진출을 위한 공동 MOU를 체결했다고 26일 밝혔다.</p>
                              <p>&nbsp;</p>
                              <p>이번 협약식에는 에듀윌 양형남 대표, EBS미디어 박성호 대표, 메이트아이 김민수 대표, 액티부키 이동원 대표 그리고 이정협 라오스 산업통상부 경제자문관 외
                                관계자들이 참석한 가운데 진행됐다. 4개사는 한국의 선진 교육 시스템과 풍부한 콘텐츠 역량을 동남아시아 시장에 접목해 새로운 성장 동력을 확보할
                                계획이다.</p>
                              <p>&nbsp;</p>
                              <p>에듀윌은 온·오프라인을 아우르는 통합 교육 시스템과 체계적인 학습 관리 솔루션 등을 바탕으로 전방위적인 교육 지원이 가능하다. 32년간 국내 교육시장에서
                                축적한 전문성을 바탕으로 동남아시아 지역에 최적화된 교육 프로그램을 개발 및 공급하고, 이를 통해 지역의 교육 수준 향상에 기여할 것이다.</p>
                              <p>&nbsp;</p>
                              <p>EBS미디어는 다양한 교육 콘텐츠와 캐릭터 IP 사업에서 강점을 활용해 동남아시아 시장에 특화된 콘텐츠를 개발하고 현지화할 예정이다. 특히, 국내외에서
                                인기를 얻고 있는 교육 콘텐츠를 바탕으로 교육 시스템을 현지 언어와 문화에 맞게 적용할 계획이다.</p>
                              <p>&nbsp;</p>
                              <p>호텔엔조이 플랫폼 운용사인 메이트아이는 국내 1세대 OTA(Online Travel Agency) 플랫폼으로서 관광 콘텐츠에 대한 풍부한 노하우를 가지고
                                있다. 이를 통해 동남아시아 시장에서 관광과 교육 콘텐츠의 융합을 시도할 예정이다. 예를 들어, 교육 프로그램을 관광 상품과 결합하여 현지 체험 학습
                                프로그램을 개발하거나, 관광지 연계 교육 투어를 제공하는 등 다양한 방식으로 비즈니스 모델을 창출할 계획이다.</p>
                              <p>&nbsp;</p>
                              <p>액티부키는 관광과 유통 분야의 디지털 전환(DX)과 라오스 시장 개척에서 이미 성공적인 사례를 보유하고 있어, 이번 협력을 통해 다양한 분야에서 시너지를
                                창출할 것으로 예상된다.</p>
                              <p>&nbsp;</p>
                              <p>이번 MOU를 통해 4개사는 동남아시아 시장의 특성에 맞는 교육 콘텐츠를 개발하고 수출하며, 이를 관광 콘텐츠와 결합한 새로운 비즈니스 모델을 구현할
                                예정이다. 또한, IP 콘텐츠를 활용한 캐릭터 상품의 유통을 추진해 현지 시장에서의 경쟁력을 강화할 계획이다. 교육과 관광, IP 콘텐츠의 융합을 통한
                                혁신적인 서비스를 제공하고, 동남아시아 소비자들에게 한국의 우수한 교육 및 문화 콘텐츠를 경험할 기회를 제공할 방침이다.</p>
                              <p>&nbsp;</p>
                              <p>특히, 이번 협약은 단순한 콘텐츠 수출을 넘어 현지 교육 및 문화 산업 발전에도 기여하는 것을 목표로 하고 있다. 동남아시아 각국의 소비자들에게 새로운
                                형태의 교육 및 문화 서비스를 제공하는 동시에 한국 콘텐츠 산업의 글로벌 경쟁력을 높일 것으로 기대된다.</p>
                              <p>&nbsp;</p>
                              <p>에듀윌, EBS미디어, 메이트아이(호텔엔조이), 액티부키는 이번 MOU 체결을 기점으로 연내에 라오스 정부 부처와 구체적인 사업논의를 시작할
                                계획이다.</p>
                              <p>&nbsp;</p>
                              <p>라오스를 시작으로 캄보디아, 베트남, 미얀마 등 동남아시아 시장 진출을 가속화하고, 정기적인 협의체 운영과 파일럿 프로그램 시행 등을 통해 현지 시장에서의
                                영향력을 확대해 나갈 예정이다. 이를 통해 한국의 교육 및 콘텐츠 산업이 세계 시장에서 지속적으로 성장할 수 있는 기반을 마련할 계획이다.<br>&nbsp;
                              </p>
                            </div>
                        </div>
                        <div class="board_nav">
                            <ul>

                                <!-- 이전 보도 기사가 있을 경우 -->

                                <li class="prev">
                                    <router-link to="/edu/newsRelease/promotionVideo/news17" data-value="315283">
                                        <strong>이전</strong>
                                        <span>에듀윌, 라오스 진출 본격화…라오스 산업통상부 차관·속싸이그룹 회장단과 회동</span>
                                    </router-link>
                                </li>

                                <!-- //이전 보도 기사가 있을 경우 -->

                              <!-- 다음 보도 기사가 있을 경우 -->
                              <li class="next">
                                <router-link to="/edu/newsRelease/promotionVideo/news15" data-value="315283">
                                  <strong>다음</strong>
                                  <span>에듀윌, ‘완성형 에듀테크 클러스터’ 조성에 박차</span>
                                </router-link>
                              </li>
                              <!-- //다음 보도 기사가 있을 경우 -->

                            </ul>
                        </div>
                        <div class="board_footer">
                            <div class="button-area">
                                <router-link to="/edu/newsRelease/main" class="lg-btn">
                                목록으로
                                </router-link>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SubHeader from "@/layouts/SubHeader";

export default {
	name: "MainOnlineEdu",
	components: {SubHeader},
	data() {
		return {
			swiper : ""
		}
	},
	
	computed: {
	},
	
	methods: {
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
		
		this.swiper = new Swiper("#vi-role.swiper-container", {
	        loop: true,
	        loopFillGroupWithBlank: true,
	        navigation: {
	          nextEl: ".swiper-button-next",
	          prevEl: ".swiper-button-prev"
	        }
	    });
		
		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
	beforeDestroy() {
	},
	destroyed() {
	}
}
</script>
